// extracted by mini-css-extract-plugin
export default {"tableStyle":"select_permissions_tableStyle__+oHFj"};